import { css } from 'lit';
export default css `
    :host([form-factor='mobile']) {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1;
    }

    :host([form-factor='tablet']),
    :host([form-factor='desktop']) {
        position: static;
    }

    .wrapper {
        --surface-transform: none; /* This messes with overflow menu positioning: fixed is no longer relative to the viewport when a parent has a transform. Why is this even set to 'translateY(0)' in the Surface component by default? Makes no sense. */

        overflow: visible;
        z-index: 1;
    }

    /**
     * Menu
     */

    .menu {
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
    }

    .menu.top-level {
        margin-inline-start: var(--spacing-neg-m);
    }

    :host([form-factor='mobile']) .menu {
        justify-content: space-evenly;
    }

    :host([form-factor='tablet']) .menu,
    :host([form-factor='desktop']) .menu {
        justify-content: flex-start;
    }

    .menu.surrogate {
        visibility: hidden;
        height: 0;
        overflow: hidden;
        pointer-events: none;
    }
`;
